import { TDeliveryTypeEnum } from '../../../graph/generated'

const DELIVERY_OPTIONS = [20, 30, 45, 60, 75, 90, 105, 120]
const PICKUP_OPTIONS = [10, 20, 30, 45, 60, 75, 90]

// We want to display different times for integration pickups than for speedlo pickups
// The reason is that integration pickups may mean that the order will be picked up by
// a courier from the integration company and not by the customer themselves
const INTEGRATION_PICKUP_OPTIONS = [3, 5, 10, 15, 20, 30, 45, 60, 75, 90]

/**
 * Returns the options for the handover time select
 * based on the delivery type
 */
export const getHandoverTimeOptions = (
  handoverType: Nullable<TDeliveryTypeEnum>,
) => {
  switch (handoverType) {
    case 'PICKUP':
      return PICKUP_OPTIONS
    case 'MESSENGER':
    default:
      return DELIVERY_OPTIONS
  }
}

/**
 * Returns the options for the handover time select for integrations
 * based on the delivery type (see comment in INTEGRATION_PICKUP_OPTIONS)
 */
export const getHandoverTimeOptionsForIntegrations = (
  handoverType: Nullable<TDeliveryTypeEnum>,
) => {
  switch (handoverType) {
    case 'PICKUP':
      return INTEGRATION_PICKUP_OPTIONS
    case 'MESSENGER':
    default:
      return DELIVERY_OPTIONS
  }
}
